const key = "selectedLanguage";
export const selectedLanguageRepo = {
  saveLanguage: (languageCode: string): void => {
    window.localStorage.setItem(key, languageCode);
  },
  getLanguage: (): string | undefined => {
    return window.localStorage.getItem(key) ?? undefined;
  },
};
